import React, {useRef, useEffect} from 'react'

//import {view} from "../../../views/mapView/MapView";
import LegendVM from './LegendVM';
const LegendWidget = ({view,layers})=>{
    const legendDiv = useRef(null);
    
    
    useEffect(()=>{
      
      if (legendDiv.current) {
        let legend
       
        legend=LegendVM(view,legendDiv.current,layers)

       return () => {
        legend.destroy();
      };
    }
  }, []);
      
  return (
    <div ref={legendDiv}></div>
  )
}

export default LegendWidget